// Google Analytics 4 helper.
// TODO: Replace GA_MEASUREMENT_ID with your real GA4 Measurement ID (G-XXXXXXXXXX).
export const GA_MEASUREMENT_ID = 'G-HPR32E3H66';

let loaded = false;

/**
 * gtag.js and the GA4 config are loaded directly in index.html (alongside the
 * Google Ads property). This function is kept for backwards compatibility with
 * main.jsx's deferred-load hook but is now a no-op — pageviews are fired by
 * NavigationTracker on every route change, and window.gtag is available from
 * the inline script in index.html before React even mounts.
 */
export function initGA() {
  loaded = true;
}

/** Fire a page_view event for a client-side route change. */
export function trackPageview(path) {
  if (typeof window === 'undefined' || !window.gtag) return;
  const fullPath = path || window.location.pathname;
  window.gtag('event', 'page_view', {
    page_path: fullPath,
    page_location: window.location.origin + fullPath,
    page_title: document.title,
  });
}

/** Fire a GA4 ecommerce `purchase` event once a Stripe checkout completes. */
export function trackPurchase(booking) {
  if (typeof window === 'undefined' || !window.gtag || !booking) return;
  window.gtag('event', 'purchase', {
    transaction_id: booking.id,
    value: Number(booking.total_price) || 0,
    currency: 'GBP',
    items: (booking.items || []).map((it, i) => ({
      item_id: it.slug || it.type || `item_${i}`,
      item_name: it.name || 'Item',
      price: Number(it.daily_rate) || (it.qty ? Number(it.total) / it.qty : 0) || 0,
      quantity: Number(it.qty) || 1,
    })),
  });
}